export const FETCH_TRANSLATION = "FETCH_TRANSLATION";

export function triggerFetchTrans(obj){
    return {
        type: FETCH_TRANSLATION,
        payload: obj
    }
}